import AOS from "aos";
import ErrorService from "services/error.service";
import SentryService from "services/sentry.service";

const InitializationService = {
	init: () => {
		// Initialize Sentry first (before other services)
		SentryService.init();
		ErrorService.init();
		AOS.init({ once: true, easing: "ease", duration: 700 });
	},
};

export default InitializationService;
